var _variants;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { FieldHeight } from '@tablekit/theme';
import { Typography } from '@tablekit/typography';
import { variant } from '@tablekit/utils';
import { ButtonSize, ButtonShape } from '../types.js';
import { getBorderRadius } from './commonStyles.js';
import { resolveColor, borderWidth } from './themeDefinitions/shared.js';
var size = variant({
  prop: 'size',
  default: ButtonSize.Regular,
  variants: (_variants = {}, _defineProperty(_variants, ButtonSize.Regular, /*#__PURE__*/css(Typography.Heading4, ";width:", FieldHeight.Regular, ";height:", FieldHeight.Regular, ";border-radius:", getBorderRadius(FieldHeight.Regular, ButtonShape.Circular), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _defineProperty(_variants, ButtonSize.Regular2, /*#__PURE__*/css(Typography.Heading4, ";width:", FieldHeight.Regular2, ";height:", FieldHeight.Regular2, ";border-radius:", getBorderRadius(FieldHeight.Regular2, ButtonShape.Circular), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _defineProperty(_variants, ButtonSize.Small, /*#__PURE__*/css(Typography.Heading4, ";width:", FieldHeight.Small, ";height:", FieldHeight.Small, ";border-radius:", getBorderRadius(FieldHeight.Small, ButtonShape.Circular), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _defineProperty(_variants, ButtonSize.Large, /*#__PURE__*/css(Typography.Heading3, ";width:", FieldHeight.Large, ";height:", FieldHeight.Large, ";border-radius:", getBorderRadius(FieldHeight.Large, ButtonShape.Circular), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:size;"))), _variants)
});

var getAppearanceCss = function getAppearanceCss(props) {
  if (props.disabled) {
    return /*#__PURE__*/css("background:", props.theme.colors.disabledBackground, ";color:", props.theme.colors.textSubtle, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:getAppearanceCss;"));
  }

  return /*#__PURE__*/css("color:", resolveColor('main', props), ";border-color:", resolveColor('main', props), ";background:transparent;" + (process.env.NODE_ENV === "production" ? "" : ";label:getAppearanceCss;"));
};

var CircleWrapper = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "eo2mn4i0"
} : {
  target: "eo2mn4i0",
  label: "CircleWrapper"
})("align-items:center;justify-content:center;transition:opacity 0.3s;border-color:transparent;border-width:", borderWidth, "px;border-style:solid;width:auto;height:auto;align-self:center;display:inline-flex;box-sizing:border-box;flex-shrink:0;margin:0;position:relative;user-select:none;", function (_ref) {
  var isLoading = _ref.isLoading;
  return isLoading ? 'opacity: 0;' : undefined;
}, " ", size, ";", getAppearanceCss, ";");

export { CircleWrapper };
